function initCustomCollectionList(root) {
  var scope = root || document;
  var splideElements = scope.querySelectorAll('.splide-carousel-section .splide-instance');
  
  splideElements.forEach(function(element) {
    if (element._splide) {
      try {
        element._splide.destroy(true);
      } catch (e) {}
    }

    var desktopPerPage = parseFloat(element.getAttribute('data-desktop-per-page')) || 4;
    var mobilePerPage = parseFloat(element.getAttribute('data-mobile-per-page')) || 1.5;
    
    var desktopArrows = element.getAttribute('data-desktop-arrows') === 'true';
    var desktopPagination = element.getAttribute('data-desktop-pagination') === 'true';
    var mobileArrows = element.getAttribute('data-mobile-arrows') === 'true';
    var mobilePagination = element.getAttribute('data-mobile-pagination') === 'true';

    var autoScroll = element.getAttribute('data-auto-scroll') === 'true' || element.getAttribute('data-autoplay') === 'true';
    var autoScrollSpeed = parseFloat(element.getAttribute('data-auto-scroll-speed') || element.getAttribute('data-autoplay-speed')) || 2;
    
    var splide = new Splide(element, {
      type: 'loop',
      perPage: desktopPerPage,
      gap: '20px',
      arrows: desktopArrows,
      pagination: false, // We use a custom progress bar if enabled
      autoplay: autoScroll,
      interval: autoScrollSpeed * 1000,
      pauseOnHover: true,
      pauseOnFocus: true,
      resetProgress: false,
      focus: 0,
      trimSpace: false,
      breakpoints: {
        768: {
          perPage: mobilePerPage,
          arrows: mobileArrows,
          pagination: false,
          gap: '15px'
        }
      }
    });

    var bar = element.querySelector('.splide-progress__bar');
    var progressContainer = element.querySelector('.splide-progress');
    
    // Hide progress container if pagination is disabled for current view
    function updateProgressVisibility() {
      var isMobile = window.innerWidth <= 768;
      if (isMobile ? mobilePagination : desktopPagination) {
        if (progressContainer) progressContainer.style.display = 'block';
      } else {
        if (progressContainer) progressContainer.style.display = 'none';
      }
    }
    
    window.addEventListener('resize', updateProgressVisibility);
    updateProgressVisibility();

    if (bar) {
      splide.on('mounted move', function () {
        var end  = splide.Components.Controller.getEnd() + 1;
        var rate = Math.min( ( splide.index + 1 ) / end, 1 );
        bar.style.width = String( 100 * rate ) + '%';
      });
    }

    splide.mount();
    element._splide = splide;
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () {
    initCustomCollectionList();
  });
} else {
  initCustomCollectionList();
}

document.addEventListener('shopify:section:load', function (event) {
  if (event.target) {
    initCustomCollectionList(event.target);
  }
});
